// Only the native marker makes profiles authoritative. Older distributed API
// contracts keep their established behavior until the server opts into native.
export const isProfileNative = user => user?.profileAuthority === 'profile'

export const profileAllowsArea = (user, area) => {
  if (!isProfileNative(user)) return area === 'universe'
    ? user?.grant_access === 'approved'
    : area === 'lite' ? user?.mvu_essentials_access === true || user?.mvu_light_access === true
      : area === 'accelerator' && user?.mvu_accelerator_access === true
  const profile = user?.userProfile
  return Object.hasOwn(user, 'blocked') && user.blocked !== true
    && Object.hasOwn(user, 'confirmed') && user.confirmed !== false
    && profile?.area === area && profile?.context_materialized === true
    && profile?.enabled === true && profile?.status === 'active'
    && profile?.profile_blocked !== true && profile?.profile_confirmed !== false
    && profile?.reconciliation_required !== true
    && (area !== 'lite' || profile.access_duration_days == null && !profile.access_expires_at
      || Boolean(profile.access_expires_at) && new Date(profile.access_expires_at).getTime() >= Date.now())
}

export const effectiveProfileTags = user => {
  if (!isProfileNative(user)) return Array.isArray(user?.tags) ? user.tags : []
  return profileAllowsArea(user, user?.userProfile?.area) && Array.isArray(user?.userProfile?.tags)
    ? user.userProfile.tags : []
}

export const normalizeProfileUser = user => {
  if (!isProfileNative(user)) return user
  const profile = user?.userProfile
  return {
    ...user,
    companyName: profile?.company_name ?? null,
    company_name: profile?.company_name ?? null,
    institution: profile?.institution ?? null,
    industry: profile?.industry ?? null,
    jobTitle: profile?.job_title ?? null,
    organization: profile?.organization ?? null,
    first_login: profile?.first_login ?? null,
    salesforceContactId: profile?.salesforceContactId ?? null,
    salesforceAccountId: profile?.salesforceAccountId ?? null,
    post_register_emails_sent_at: profile?.onboarding_emails_sent_at ?? null,
    salesforceIntegrationStatus: profile?.salesforce_integration_status ?? null,
    staff_upload: profile?.staff_upload ?? null,
    tags: effectiveProfileTags(user),
    grant_access: profileAllowsArea(user, 'universe') ? 'approved' : profile?.area === 'universe' ? profile?.status || 'none' : 'none',
    mvu_light_access: profileAllowsArea(user, 'lite'),
    mvu_essentials_access: profileAllowsArea(user, 'lite'),
    mvu_accelerator_access: profileAllowsArea(user, 'accelerator'),
    can_approve_accelerator_certificates: Object.hasOwn(user, 'blocked') && user.blocked !== true
    && Object.hasOwn(user, 'confirmed') && user.confirmed !== false
      && user?.profilePermissions?.can_approve_accelerator_certificates === true,
  }
}

export const profileCompletionPath = area => area === 'lite' ? '/mvu-lite/complete-profile'
  : area === 'accelerator' ? '/mvu-accelerator/complete-profile' : '/complete-profile'
export const profileNeedsCompletion = user => isProfileNative(user) && user?.userProfile?.profile_completion_required === true
export const passwordChangeRequired = user => user?.passwordChangeRequired === true
export const passwordChangePath = area => area === 'lite' ? '/mvu-lite/change-password'
  : area === 'accelerator' ? '/mvu-accelerator/change-password' : '/change-password'

const completionFields = ['firstName', 'lastName', 'country', 'companyName', 'industry', 'jobTitle']
export const profileMissingFields = user => {
  if (!profileNeedsCompletion(user)) return []
  if (Array.isArray(user?.userProfile?.missing_fields)) return completionFields.filter(field => user.userProfile.missing_fields.includes(field))
  // Compatibility with earlier session responses; the server revalidates data.
  return completionFields.filter(field => typeof user?.[field] !== 'string' || !user[field].trim())
}
